"use client";
import React from "react";
import { allTab } from "@/constants/common";
import { Tabs } from "antd";

import styles from "./index.module.scss";

export default function CommonTabList({
  tabId = "",
  activeIndex = "1",
  changeActive,
  customList = [],
  showNode,
}: {
  tabId?: string;
  activeIndex: string;
  customList?: any[];
  changeActive?: (activeKey: string) => void;
  showNode?:React.ReactNode;
}) {
  return (
    <div className={styles.commonTabs}>
      <Tabs
        onChange={changeActive}
        defaultActiveKey={activeIndex}
        activeKey={activeIndex}
        items={(allTab[tabId] || customList).map(
          (
            t: { name: string; key: string; children?: React.ReactNode },
            key: number
          ) => {
            return {
              key: t.key,
              label: (
                <span
                  className={`iconBox ${tabId ? tabId : t.key}Icon${key} ${
                    tabId ? tabId : t.key
                  }Icon`}
                  key={key}
                >
                  {t.name}
                </span>
              ),
              children: t.children ? (
                <div className="wrapper hCenter">
                  {
                    showNode?showNode:t.children
                  }
                </div>
              ) : (
                ""
              ),
            };
          }
        )}
      />
    </div>
  );
}
